import Typography from '@/components/Typography';
import { Box } from '@mui/material';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';

const BasicUserView = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      gap: '16px',
      paddingTop: '48px'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '62px',
        '& > *': {
          fontSize: '16px',
          fontWeight: 600
        }
      }}
    >
      <Typography>This is a Premium feature</Typography>
      <Typography>Upgrade for advanced functionality and exports</Typography>
    </Box>
    <UpgradeToPremiumButton type='upgrade' />
  </Box>
);

export default BasicUserView;
